import { render, staticRenderFns } from "./ManageAvatarCustomImage.vue?vue&type=template&id=75da5223&"
import script from "./ManageAvatarCustomImage.vue?vue&type=script&lang=js&"
export * from "./ManageAvatarCustomImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports